import React from 'react'
import { Link as RouterLink, useInRouterContext } from 'react-router-dom'
import { Box, Link, Typography } from '@mui/material'
import ROUTES from '../../routesConfig'

const linkSx = {
  color: 'rgba(230,233,239,0.72)',
  fontSize: '0.8rem',
  textDecoration: 'none',
  '&:hover': {
    color: '#93C5FD',
    textDecoration: 'underline'
  }
}

const LegalFooterLinks = ({ sx = {} }) => {
  const inRouterContext = useInRouterContext()
  const linkProps = (to) => (
    inRouterContext
      ? { component: RouterLink, to }
      : { href: to }
  )

  return (
    <Box
      sx={{
        pt: 0.5,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
        flexWrap: 'wrap',
        ...sx
      }}
    >
      <Link {...linkProps(ROUTES.PRIVACY)} sx={linkSx}>
        Privacy
      </Link>
      <Typography sx={{ color: 'rgba(230,233,239,0.38)', fontSize: '0.8rem' }}>
        |
      </Typography>
      <Link {...linkProps(ROUTES.TERMS)} sx={linkSx}>
        Terms
      </Link>
    </Box>
  )
}

export default LegalFooterLinks
